import React, { Component } from 'react';
import axios from '../../../axios-ns';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Aux from '../../../hoc/Aux';
import MuiAudioPlayer from '../../AudioPlayer';
import * as messages from '../../../messages';

class StudentVerifications extends Component {
    state = {
        samples: null,
        loading: true,
        open: false,
        form: {
            scaleScore: 1,
            scaleDescription: messages['scale_1'],
            rythmScore: 1,
            rythmDescription: messages['rythm_1'],
            relativeAltitudeHearingScore: 1,
            relativeAltitudeHearingDescription: messages['relativeAltitudeHearing_1'],
            // harmonicHearingScore: 1,
            // harmonicHearingDescription: '',
            melodicHearingScore: 1,
            melodicHearingDescription: messages['melodicHearing_1'],
            dictionScore: 1,
            dictionDescription: messages['diction_1']
        }
    }

    handleClickOpen = (sampleCode) => {
        this.setState({
            open: true,
            selectedValue: sampleCode
        });
    };

    handleClose = value => {
        axios.get('protected/audio/analysis/samples/CREATED', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                this.setState({ ...this.state, samples: response.data, loading: false, open: false });
            }).catch(err => {
                this.setState({ ...this.state, loading: false });
                console.log("error");
            })
    };

    componentDidMount() {
        if (localStorage.getItem('token')) {
            axios.get('protected/audio/analysis/students/WAITING_FOR_EVALUATION', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {
                    let samples = response.data.map(s => {
                        s['form'] = Object.assign({}, this.state.form);
                        return s;
                    });
                    this.setState({ samples: samples, loading: false });
                }).catch(err => {
                    this.setState({ loading: false });
                    console.log("error");
                })
        }
    }

    handleChange = (event, studentSampleCode, field, type) => {
        let form = this.state.form;
        let samples = this.state.samples.map(s => {
            if (s.studentSampleCode === studentSampleCode) {
                s.form[field] = event.target.value;
                if(type === 'SELECT') {
                    let fld = field.substring(0, field.indexOf('Score'));
                    s.form[fld + 'Description'] = messages[fld + "_" + event.target.value];
                }
            }
            return s;
        })
        this.setState({ ...this.state, samples: samples });
        //alert(JSON.stringify(this.state));
    }

    handleSubmit = (event, code) => {
        event.preventDefault();
        let obj = this.state.samples.find(s => s.code == code).form;
        obj['transactionCode'] =  code;
        //alert(JSON.stringify(obj));
        
        //console.log(obj);
        axios.post('protected/audio/analysis/student', obj, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                document.location.reload();
            }).catch(err => {
                console.log("Err");
            });
    }

    render() {
        let samples = null;

        if (this.state.samples) {
            if (this.state.samples.length === 0) {
                samples = <p>Brak nowych nagrań do oceny</p>
            } else {
                samples = this.state.samples.map(s => {

                    let controls = Object.keys(s.form).filter(k => k.indexOf('Description') > -1 || k.indexOf('Score') > -1).map(k => {
                        if (k.indexOf('Description') > -1) {
                            return (<Aux><TextField key={k}
                                id="outlined-multiline-flexible"
                                label={messages[k]}
                                multiline
                                rowsMax="4"
                                style={{width: '500px'}}
                                value={s.form[k]}
                                onChange={(event) => this.handleChange(event, s.studentSampleCode, k, 'INPUT')}
                                margin="normal"
                                helperText="Opisz proszę możliwie precyzyjnie swoją ocenę."
                            /><hr/></Aux>);
                        } else if (k.indexOf('Score') > -1) {
                            return (<Aux  key={k}>
                                <InputLabel htmlFor="filled-age-simple">{messages[k]}: </InputLabel>
                                <Select
                                    value={s.form[k]}
                                    onChange={(event) => this.handleChange(event, s.studentSampleCode, k, 'SELECT')}
                                >
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                </Select>
                            </Aux>
                            );
                        }
                    });

                    let songs = s.songs.map(s => <MuiAudioPlayer src={s.path} onClick={() => {}} />);

                    return (
                        <Card key={s.code} style={{ width: '100%' }}>
                            <CardContent>
                                <b>Uczeń: {s.firstName}, {s.email}</b>
                                <h5>Nagrania:</h5>
                                {songs}

                                <Card style={{ padding: '10px' }}>
                                    <form onSubmit={(event) => this.handleSubmit(event, s.code)}>
                                        {controls}
                                        <Button variant="outlined" type="submit" color="primary">Wyślij</Button>
                                    </form>
                                </Card>
                            </CardContent>
                        </Card>
                    )
                });
            }
        }

        let view = null;

        if (this.state.loading) {
            view = <Spinner />
        } else {
            view = (<Aux>
                {samples}
            </Aux>);
        }

        return (view);

    };
}

export default StudentVerifications;